module.exports = __webpack_public_path__ + "media/33_BL.c2d09df8.mp3";